module.exports = __webpack_public_path__ + "img/default-avatar.dee46f6f.png";